import { useEffect, useState } from "react";
import Swal from "sweetalert2";

import api from "../services/api";
import Navbar from "../components/Navbar";
import { useAuth } from "../context/AuthContext";

function CreateExam() {

  const { token } = useAuth();

  const [categories, setCategories] = useState([]);

  const [pdfFile, setPdfFile] = useState(null);

  const [thumbnailFile, setThumbnailFile] =
    useState(null);

  const [creating, setCreating] =
    useState(false);

  const [formData, setFormData] = useState({
    title: "",
    slug: "",
    description: "",
    price: 0,
    is_free: true,
    category_id: ""
  });

  useEffect(() => {

    fetchCategories();

  }, []);

  const fetchCategories = async () => {

    try {

      const response =
        await api.get("/categories");

      setCategories(response.data);

    } catch (error) {

      console.error(error);

    }

  };

  const handleChange = (e) => {

    const {
      name,
      value,
      checked,
      type
    } = e.target;

    setFormData({

      ...formData,

      [name]:
        type === "checkbox"
          ? checked
          : value

    });

  };

  const uploadPDF = async () => {

    if (!pdfFile) {

      throw new Error(
        "Please select a PDF."
      );

    }

    const uploadData =
      new FormData();

    uploadData.append(
      "file",
      pdfFile
    );

    const response =
      await api.post(
        "/upload/exam",
        uploadData,
        {
          headers: {
            Authorization:
              `Bearer ${token}`,
            "Content-Type":
              "multipart/form-data"
          }
        }
      );

    return response.data.file_url;

  };

  const uploadThumbnail =
    async () => {

      if (!thumbnailFile) {

        return "";

      }

      const uploadData =
        new FormData();

      uploadData.append(
        "file",
        thumbnailFile
      );

      uploadData.append(
        "folder",
        "thumbnails"
      );

      const response =
        await api.post(
          "/upload/image",
          uploadData,
          {
            headers: {
              Authorization:
                `Bearer ${token}`,
              "Content-Type":
                "multipart/form-data"
            }
          }
        );

      return response.data.image_url;

    };

  const resetForm = () => {

    setFormData({

      title: "",
      slug: "",
      description: "",
      price: 0,
      is_free: true,
      category_id: ""

    });

    setPdfFile(null);

    setThumbnailFile(null);

  };

  const handleSubmit =
    async (e) => {

      e.preventDefault();

      try {

        setCreating(true);

        Swal.fire({

          title:
            "Creating Exam...",

          text:
            "Uploading files, please wait.",

          allowOutsideClick:
            false,

          didOpen: () => {

            Swal.showLoading();

          }

        });

        const file_url =
          await uploadPDF();

        const thumbnail_url =
          await uploadThumbnail();

        await api.post(

          "/exams",

          {

            ...formData,

            file_url,

            thumbnail_url,

            price:
              Number(
                formData.price
              ),

            category_id:
              Number(
                formData.category_id
              )

          },

          {

            headers: {

              Authorization:
                `Bearer ${token}`

            }

          }

        );

        Swal.fire({

          icon: "success",

          title:
            "Success",

          text:
            "Exam created successfully.",

          timer: 2000,

          showConfirmButton:
            false

        });

        resetForm();

      } catch (error) {

        console.error(error);

        Swal.fire({

          icon: "error",

          title:
            "Creation Failed",

          text:
            error.response?.data
              ?.message ||
            error.message ||
            "Unable to create exam."

        });

      } finally {

        setCreating(false);

      }

    };

  return (

  <div>

    <Navbar />

    <div className="form-container">

      <h1>Create Exam</h1>

      <form onSubmit={handleSubmit}>

        <input
          type="text"
          name="title"
          placeholder="Title"
          value={formData.title}
          onChange={handleChange}
          required
        />

        <input
          type="text"
          name="slug"
          placeholder="Slug"
          value={formData.slug}
          onChange={handleChange}
          required
        />

        <textarea
          name="description"
          placeholder="Description"
          value={formData.description}
          onChange={handleChange}
        />

        <input
          type="number"
          name="price"
          placeholder="Price"
          value={formData.price}
          onChange={handleChange}
        />

        <div
          style={{
            marginTop: "15px",
            marginBottom: "15px"
          }}
        >

          <label>

            <strong>
              Exam PDF
            </strong>

          </label>

          <input
            type="file"
            accept=".pdf"
            onChange={(e) =>
              setPdfFile(
                e.target.files[0]
              )
            }
            required
          />

        </div>

        <div
          style={{
            marginTop: "15px",
            marginBottom: "15px"
          }}
        >

          <label>

            <strong>
              Thumbnail Image
            </strong>

          </label>

          <input
            type="file"
            accept="image/*"
            onChange={(e) =>
              setThumbnailFile(
                e.target.files[0]
              )
            }
          />

        </div>

        <select
          name="category_id"
          value={formData.category_id}
          onChange={handleChange}
          required
        >

          <option value="">
            Select Category
          </option>

          {categories.map(
            (category) => (

              <option
                key={category.id}
                value={category.id}
              >

                {category.name}

              </option>

            )
          )}

        </select>

        <label
          style={{
            display: "block",
            marginTop: "15px"
          }}
        >

          Free Exam{" "}

          <input
            type="checkbox"
            name="is_free"
            checked={formData.is_free}
            onChange={handleChange}
          />

        </label>

        <button
          type="submit"
          disabled={creating}
        >

          {creating
            ? "Creating Exam..."
            : "Create Exam"}

        </button>

      </form>

    </div>

  </div>

);

}

export default CreateExam;